export var dataProperties={businessName:'businessName',logo:'logo'};export var businessNameMaxCount=90;